export default __webpack_public_path__ + "static/Hepatofelin-mobile-82b5d14f4992eba74f7db2bb4d376350.jpg";